import { Button } from '@components/button';
import { Typography } from '@components/typography';
import { Stack, useTheme } from '@mui/material';
import { navigate } from 'gatsby';

export const CookiesCloseModal = ({
  handleAcceptCookieAll,
}: {
  handleAcceptCookieAll: () => void;
}) => {
  const { palette } = useTheme();

  const handleRejectButton = () => {
    navigate('/sign-in');
  };
  return (
    <Stack width="500px" bgcolor={palette.background.paper} px={10} alignItems="center" gap={8}>
      <Typography variant="h3" textAlign="center">
        Consent to use cookies required
      </Typography>
      <Typography textAlign="center">
        Rendered.ai requires your consent to use cookies to enable our user experience. If you don’t
        want us to use cookies, you will be signed out of the application
      </Typography>
      <Stack gap={4} width="100%" justifyContent="center" flexDirection="column">
        <Button onClick={handleAcceptCookieAll} fullWidth>
          Accept all
        </Button>
        <Button variant="secondary" onClick={handleRejectButton} fullWidth>
          Reject
        </Button>
      </Stack>
    </Stack>
  );
};
